<template>
  <div
    data-component-group="invoice-form"
    data-component="edit"
    class="elevation-1"
  >
    <div class="component-body">
      <InvoiceForm
        :invoice="invoice"
        :is-disabled="true"
        :on-submit="() => {}"
      >
        <template v-slot:beforeForm>
          <layout-section-header title="Details" :has-trigger="false" />
        </template>
      </InvoiceForm>

      <div class="invoice-pdf">
        <layout-section-header
          title="Invoice PDF"
          :has-trigger="hasPdf"
          trigger-label="Download"
          :title-right-text="hasPdf ? '' : 'No PDF for this invoice'"
          class="elevation-1"
          @toggle="onDownloadPdf"
        />
      </div>

      <PaymentForm :invoice="invoice">
        <template v-slot:beforeForm>
          <layout-section-header
            title="Payment information"
            :has-trigger="false"
          />
        </template>
      </PaymentForm>

      <InvoiceLines :items="invoiceLines" :currency="invoiceCurrency">
        <template v-slot:beforeForm>
          <layout-section-header title="Invoice lines" :has-trigger="false" />
        </template>
      </InvoiceLines>

      <Totals :invoice="invoice">
        <template v-slot:beforeForm>
          <layout-section-header title="Totals" :has-trigger="false" />
        </template>
      </Totals>
    </div>
  </div>
</template>

<script>
  import InvoiceForm from './AddNew';
  import PaymentForm from './Payment';
  import Totals from './Totals';
  import InvoiceLines from '../../lists/InvoiceLines';
  import defaultPagination from '../../../config/pagination';
  import { isObj } from '../../../utils';

  // TODO: Translate component

  export default {
    components: {
      InvoiceForm,
      PaymentForm,
      Totals,
      InvoiceLines,
    },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        pagination: {
          ...defaultPagination,
        },
      };
    },
    computed: {
      invoiceLines() {
        const { lines = [] } = this.invoice || {};
        return lines;
      },
      invoiceCurrency() {
        const { currency = {} } = this.invoice.cost_center || {};
        return currency;
      },
      // Only invoices PB numbered and rendered before the ERP took over have a file.
      hasPdf() {
        return Boolean(this.invoice?.has_pdf);
      },
    },
    watch: {
      invoice(nextInvoice) {
        if (isObj(nextInvoice)) {
          this.pagination = defaultPagination;
        }
      },
    },
    methods: {
      onDownloadPdf() {
        const { id } = this.invoice;

        return this.$store.dispatch('invoices/downloadInvoice', { id });
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='invoice-form'][data-component='edit'] {
  .v-btn {
    margin: 0;
  }

  .invoice-pdf {
    [data-component='section-header'] {
      padding: $spacing-xl;
      background-color: rgb(var(--v-theme-surface));
      border-top: 1px solid map.get($colors, grey, lighten-2);
    }
  }
}
</style>
